// extracted by mini-css-extract-plugin
export default {"toolbarButton":"toolbarButton__U_B7AR"};